/**
 * @author Ariel
 * @date 2021-12-23
 */
import React from "react";
import {connect} from "dva";
import {framework_tool, component_tool, utils_tool} from '../../../../../tool'
import {Descriptions} from "antd";
import ModalPlayer from '../../components/modalPlayer'

let {WizContainer, modelUtils, WizAvatarUpload, WizOssUpload} = framework_tool
let {WizCard, WizSpin, WizForm, WizButton, Wizmessage, WizCol, WizIcon, WizInput, WizModal} = component_tool
let {Session} = utils_tool


function defaultImgList(fileIds) {
  let imgs = []
  let fileList = fileIds && fileIds.split(',')

  if (fileList && fileList.length && fileList.length > 0) {
    fileList.forEach(fileId => {
      imgs.push({url: getOssFilePath(fileId), uid: new Date().getTime() + fileId})
    })
  }
  return imgs
}

class ShortVideoScreenToDeal extends WizContainer {
  componentName = 'shortVideoScreenToDeal'

  constructor(props) {
    super(props)
    const {history} = props
    let shortVideoInfo = {};
    if (history.location && history.location.record) {
      shortVideoInfo = history.location.record
      Session.set('shortVideoInfo', shortVideoInfo)
    } else {
      shortVideoInfo = Session.get('shortVideoInfo') || {}
    }
    this.shortVideoInfo = shortVideoInfo
    this.state = {
      screenId: shortVideoInfo.id || shortVideoInfo.screenId,
      shortVideoId: shortVideoInfo.shortVideoId,
      visible: false,
      videoUrl: '',
      formTypeSwitch: 'hidden'
    }
  }

  _componentDidMount() {
    if (this.state && this.state.shortVideoId) {
      this.doAction({
        path: 'shortVideo/look',
        payload: {
          key: 'shortVideoInfo',
          apiParams: {id: this.state.shortVideoId}
        }
      })
    }
    if (this.state && this.state.screenId) {
      this.doAction({
        path: 'shortVideoScreen/look',
        payload: {
          key: 'shortVideoScreenInfo',
          apiParams: {id: this.state.screenId}
        }
      })
    }
  }

  propsAndStateOnChange = {
    shortVideoToDeal: this._shortVideoToDealOver.bind(this),
    shortVideoScreenInfo: this._shortVideoScreenInfoOver.bind(this)
  }

  _shortVideoToDealOver(nextProps, nextState) {
    if (nextProps.shortVideoToDeal.code == 1) {
      wizNotice.success('处理成功');
      this.jumpPage('replace', '/shortVideoScreen');
    } else {
      wizNotice.error('处理失败：' + nextProps.shortVideoToDeal.msg);
    }
    return true;
  }

  _shortVideoScreenInfoOver(nextProps, nextState) {
    if (nextProps.shortVideoScreenInfo.code == 1) {
      nextState.shortVideoScreenInfo = nextProps.shortVideoScreenInfo.data
      nextState.changeImg = nextProps.shortVideoScreenInfo.data && nextProps.shortVideoScreenInfo.data.files

      let shortVideoScreenInfo = nextProps.shortVideoScreenInfo.data
      let {formTypeSwitch, shortVideoScreenState, shortVideoScreenType} = this.state
      if (shortVideoScreenInfo) {
        shortVideoScreenState = shortVideoScreenInfo.state
        if (shortVideoScreenInfo.state === 0) {
          shortVideoScreenState = null
          shortVideoScreenType = null
        }
        if (shortVideoScreenInfo.state === 1) {
          formTypeSwitch = 'select'
          shortVideoScreenState = 1
        }
        if (shortVideoScreenInfo.state === 2) {
          formTypeSwitch = 'hidden'
          shortVideoScreenType = null
        }

        shortVideoScreenType = shortVideoScreenInfo.type && shortVideoScreenInfo.type >= 0 ? shortVideoScreenInfo.type : null
      }
      nextState.shortVideoScreenState = shortVideoScreenState
      nextState.shortVideoScreenType = shortVideoScreenType
      nextState.formTypeSwitch = formTypeSwitch
    } else {
      wizNotice.error('查询失败：' + nextProps.shortVideoScreenInfo.msg);
    }
    return true;
  }

  _shortVideoToDeal(values) {
    let {changeImg, screenId} = this.state
    let imgList = []
    changeImg && changeImg.length && Array.isArray(changeImg) && changeImg.forEach(img => {
      imgList.push(img.fileId)
    })
    if (!Array.isArray(changeImg)) {
      imgList.push(changeImg)
    }
    if (imgList && imgList.length && imgList.length > 3) {
      wizNotice.error('最多上传3张图片')
      return false;
    } else {
      values['files'] = imgList
      values['id'] = screenId
      let apiPath = 'shortVideoScreen/toDeal';
      this.doAction({
        path: apiPath,
        payload: {
          key: 'shortVideoToDeal',
          apiParams: {...values}
        }
      })
    }
  }

  _stateOnChange = (form, value) => {
    form.resetFields(['type']);
    this.setState({
      formTypeSwitch: value === 1 ? 'select' : 'hidden'
    })
  }

  _render() {
    const {shortVideoInfo, shortVideoLoading} = this.props
    let columns = () => {
      let {formTypeSwitch, shortVideoScreenInfo, shortVideoScreenState, shortVideoScreenType} = this.state
      return [
        {
          name: 'id',
          formItem: {
            type: 'hidden',
          }
        },
        {
          name: 'shortVideoId',
          formItem: {
            type: 'hidden',
          }
        },
        {
          title: '处理结果',
          name: 'state',
          formItem: {
            type: 'select',
            initialValue: shortVideoScreenState,
            onChange: this._stateOnChange,
            rules: [
              {
                required: true,
                message: '请选择处理结果'
              }
            ],
          },
          dict: [
            {code: 1, codeName: '屏蔽'},
            {code: 2, codeName: '无需屏蔽'}
          ]
        },
        {
          title: '屏蔽类型',
          name: 'type',
          formItem: {
            type: formTypeSwitch,
            initialValue: shortVideoScreenType,
            rules: [
              {
                required: formTypeSwitch === 'select',
                message: '请选择屏蔽类型'
              }
            ],
          },
          dict: [
            {code: 1, codeName: '违法违规'},
            {code: 2, codeName: '色情低俗'},
            {code: 3, codeName: '诈骗信息'},
            {code: 4, codeName: '低差广告'},
            {code: 5, codeName: '虚假不实'},
            {code: 6, codeName: '搬运抄袭'},
            {code: 7, codeName: '谩骂攻击'},
            {code: 8, codeName: '涉未成年人'},
            {code: 9, codeName: '时政不实信息'},
            {code: 10, codeName: '引人不适'},
            {code: 11, codeName: '诱导关注点赞'},
            {code: 12, codeName: '侵权投诉'},
            {code: 999, codeName: '其他'},
          ]
        },
        {
          title: '处理原因',
          name: 'remark',
          formItem: {
            type: 'textarea',
            initialValue: shortVideoScreenInfo && shortVideoScreenInfo.remark,
            maxLength: 50,
            placeholder: '介绍最多输入50个字',
          }
        },
        {
          title: '证据',
          name: 'files',
          formItem: {
            type: 'custom',
            render: (record, form) => {
              const {getFieldDecorator} = form;
              let {changeImg} = this.state
              let children = changeImg && changeImg.length >= 3 ? null : <WizButton>选择文件</WizButton>
              return (
                <div>
                  {
                    getFieldDecorator('imgList', {
                      initialValue:
                        (shortVideoScreenInfo && shortVideoScreenInfo.files) ? defaultImgList(shortVideoScreenInfo.files) : [],
                    })(
                      <WizOssUpload
                        accept={'.jpg, .jpeg, .png'}
                        listType={'picture-card'}
                        uploadType={'shortVideoScreen'}
                        onChange={(files) => {
                          this.setState({
                            changeImg: files,
                            changeImgTime: new Date()
                          })
                        }}
                        children={children}
                      />
                    )}
                </div>
              )
            }
          }
        },
      ]
    }

    let onSubmit = this._shortVideoToDeal.bind(this)

    let formProps = {
      ref: 'form',
      columns: columns(),
      onSubmit,
      record: null,
      preview: null,
      footer: undefined,
      formItemLayout: {
        labelCol: {span: 4},
        wrapperCol: {span: 17}
      }
    }

    if (shortVideoInfo && shortVideoInfo.success) {
      this.shortVideoInfo = shortVideoInfo.data
    }
    const items = this.shortVideoInfo
    let labelIds = []
    items['labelIds'] && items['labelIds'].length && items['labelIds'].forEach(item => {
      labelIds.push(item.name)
    })
    items['labelNames'] = labelIds && labelIds.length > 0 ? labelIds.join(",") : ''

    let {visible, videoUrl} = this.state
    const modalProps = {
      visible,
      videoUrl,
      setVisible: () => this.setState({visible: false, videoUrl: ''})
    }

    return (
      <React.Fragment>
        <WizCard title={'基础信息'}>
          <Descriptions column={2} style={{paddingLeft: 25}}>
            <Descriptions.Item label='标题'>
              <>
                <span style={{marginRight: 10}}>{items.title}</span>
                <WizButton type='primary' shape='round' size='small'
                           onClick={() => this.setState({visible: true, videoUrl: items.video})}>
                  播放
                </WizButton>
              </>
            </Descriptions.Item>
            <Descriptions.Item label='标签'>{items.labelNames}</Descriptions.Item>
            <Descriptions.Item label='发布人'>{items.fullName}</Descriptions.Item>
            <Descriptions.Item label='发布时间'>{items.releaseTime}</Descriptions.Item>
          </Descriptions>
        </WizCard>

        <WizCard title={'处理'}>
          <WizSpin tip={'加载中'} spinning={shortVideoLoading}>
            <WizForm className={'form-inline'} {...formProps} />
          </WizSpin>
        </WizCard>
        <ModalPlayer {...modalProps} />
      </React.Fragment>

    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const {shortVideo, shortVideoScreen} = state;
  const shortVideoToDeal = modelUtils.getModelEntity(shortVideoScreen, 'shortVideoToDeal');
  const shortVideoScreenInfo = modelUtils.getModelEntity(shortVideoScreen, 'shortVideoScreenInfo');
  const shortVideoInfo = modelUtils.getModelEntity(shortVideo, 'shortVideoInfo');
  const load = modelUtils.getLoadingState(state, 'shortVideo');
  return {
    shortVideoToDeal,
    shortVideoScreenInfo,
    shortVideoInfo,
    ...load
  }
}

export default connect(mapStateToProps)(ShortVideoScreenToDeal);
